<!-- 会员等级变更日志 -->
<template>
    <page>
        <c-dialog ref="memberDialog" :title="title" width="600" height="630" enable-flex @resolve="setMemberHandle">
            <c-form ref="memberForm">
                <c-form title="会员信息" title-margin="10">
                    <c-form-item type="input" label="昵称:" name="nick_name" disabled></c-form-item>
                    <c-form-item type="input" label="手机号:" name="user_manage_mobilephone" disabled></c-form-item>
                </c-form>
                <c-form title="邀请人" title-margin="10">
                    <c-form-item type="input" label="当前邀请人:" name="share_user_name" disabled></c-form-item>
                    <c-form-item type="hidden" name="share_user_id"></c-form-item>
                    <c-form-item type="input" @click="$refs.memberUserSelector.open()" readonly label="修改为:" name="tran_share_user_name" required word="调整后该用户后续带来的收益奖归于新的邀请人下"></c-form-item>
                </c-form>
                <c-form title="等级身份" title-margin="10">
                    <c-form-item type="input" label="身份等级:" name="user_level_name" disabled></c-form-item>
                    <!-- <c-form-item type="select" label="调整为:" name="user_level" options="USER_LEVEL_AUTH_SELECT" required></c-form-item> -->
					<c-form-item type="radio" label="修改为:" name="is_ywy" required :options="sflxOption"></c-form-item>
                </c-form>
            </c-form>
        </c-dialog>
        <member-user-selector ref="memberUserSelector" @resolve="selectHandle($event)"></member-user-selector>
    </page>
</template>

<script>
	import memberUserSelector from "@/components/service/member_user_selector.vue";

    export default {
        components: {memberUserSelector},
		props: {
        },

        data() {
            return {
                platform_user_id:0,
                title:'调整邀请人/等级',
                serachParams:{},
				sflxOption: [{
				    name: '代理/会员',
				    value: 1
				},{
				    name: '业务员',
				    value: 2
				}],
            }
        },
		
		methods: {
			open(data) {
                this.platform_user_id = data.platform_user_id;
                this.$refs.memberForm.clear();
                this.$refs.memberForm.set({
                    share_user_name: (data.share_user_nick_name || "") + "【" + (data.share_user_manage_mobilephone || '--') + "】",
                    tran_share_user_name: (data.share_user_nick_name || "") + "【" + (data.share_user_manage_mobilephone || '--') + "】",
                    user_level_name: data.user_level_name || '普通用户',
                    share_user_id: data.share_user_id,
                    //user_level: data.user_level==40,
					is_ywy: data.user_level == 40? 2:1,
                    nick_name: data.nick_name,
                    user_manage_mobilephone: data.user_manage_mobilephone
                });
                this.$refs.memberDialog.open();
			},

            //选择会员回调方法
            selectHandle(list) {
                var tran_share_user_name = "--";
                var share_user_id = -1;
                if (list && list[0]) {
                    console.log(list[0]);
                    tran_share_user_name = (list[0].nick_name || "--") + "【" + list[0].user_manage_mobilephone || "--" + "】";
                    share_user_id = list[0].platform_user_id || -1;
                }
                this.$refs.memberForm.set({
                    tran_share_user_name: tran_share_user_name,
                    share_user_id: share_user_id,
                });
            },
            //保存调整会员等级
            setMemberHandle(stop) {
                stop();
                this.$refs.memberForm.submit({
                    url: '/member_user/adjustment',
                    rule: {
                        share_user_id: '请设置邀请人'
                    },
                    dataFormatter: data => {
                        data.member_user_id = this.platform_user_id;
                        data.user_level = (data.is_ywy == 2? 40:(data.user_level || -99));
                        delete data.tran_share_user_name;
                        return data;
                    },

                    success: data => {
                        this.$refs.memberDialog.close();
                        this.$message({
                            text: '请求发送成功，调整结果可能稍有延迟!'
                        });
                        //调用响应方法
                        this.$emit('resolve',this.platform_user_id);
                    }
                })
            }
        }
	}
</script>